module.exports = __webpack_public_path__ + "static/media/test_specialFormatting_none.2d8260c4.csv";